import { parseISO } from 'date-fns';

export const cryptocurrencyAmountTypePolicy = {
  read(value?: string | null) {
    return value ? BigInt(value) : value;
  },
};

export const dateTypePolicy = {
  read(value?: string | null | Date) {
    if (value instanceof Date) return value;
    if (!value) return value;
    // Date-only ISO strings (YYYY-MM-DD, ISO8601Date scalar) parse as
    // local-time midnight via parseISO, which shifts the day for users
    // east of UTC when the date is later read back via getUTC* / timeZone="UTC".
    if (/^\d{4}-\d{2}-\d{2}$/.test(value))
      return new Date(`${value}T00:00:00Z`);
    return parseISO(value);
  },
};
